// extracted by mini-css-extract-plugin
module.exports = {"formControl":"Info_formControl_3lEbV"};